import {
  Box,
  Grid,
  IconButton,
  Stack,
  Typography,
  Paper,
  ListItem,
  List,
  ListItemText,
  Divider,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import CloseIcon from '@mui/icons-material/Close';
import { Transition } from '../transition';
import { AppColors, config, typographyClamps } from '../../utils/utils';
import { priceFormatter } from '../../utils/utilMethods';
import VideoModel from './VideoModel';
import { useEffect, useState } from 'react';
import useToggle from '../../hooks/useToggle';
import LockIcon from '@mui/icons-material/Lock';
import { GradientButton } from '../GradientButton';

interface Feature {
  iconPath?: string;
  title: string;
}

const featureList: Feature[] = [
  {
    // iconPath: '/static/images/list_1.png',
    title: 'Click Pay Now to finish your order and create your login.',
  },
  {
    // iconPath: '/static/images/list_2.png',
    title: 'Confirm your billing details are correct.',
  },
  // {
  //   // iconPath: '/static/images/list_3.png',
  //   title:
  //     ' Receive 100 QR Buddy window clings shipped via UPS within 3 business days.',
  // },
  {
    // iconPath: '/static/images/list_4.png',
    title:
      'Access your back office for ordering more clings and downloading signage graphics.',
  },
];

// interface IBookDemoFormState {
//   first_name: string;
//   last_name: string;
//   name: string;
//   dealership_name: string;
//   location: string;
//   position: string;
//   no_of_sales_people: number;
//   office_number: string;
//   office_number_ext?: string;
//   office_email: string;
//   mobile_number?: string;
//   member_of_dealer_group: number;
//   contact_time?: string;
//   sales_rep?: string;
// }

interface IProps {
  toggle: boolean;
  onClose: () => void;
  onSubmitSuccess?: (code: string) => void;
}

const GetStartedModel: React.FC<IProps> = ({
  toggle,
  onClose,
  onSubmitSuccess,
}) => {
  const [videoUrl, setVideoUrl] = useState<string | undefined>();
  const [sendFeeReceipt, setSendFeeReceipt] = useState<boolean>(false);

  const {
    toggle: toggleVideo,
    onOpen: onOpenVideo,
    onClose: onCloseVideo,
  } = useToggle();

  const listItemStyle = {
    '& .MuiListItemSecondaryAction-root': {
      right: 0,
    },
    pl: 0,
  };

  const priceTextStyle = {
    color: AppColors.blackColor,
    fontSize: typographyClamps.subtitle2,
    fontWeight: 600,
  };

  // const {
  //   handleSubmit,
  //   values,
  //   resetForm,
  //   isSubmitting,
  //   errors,
  //   touched,
  //   handleChange,
  // } = useFormik<IBookDemoFormState>({
  //   initialValues: {
  //     first_name: '',
  //     last_name: '',
  //     name: '',
  //     dealership_name: '',
  //     location: '',
  //     position: '',
  //     member_of_dealer_group: 0,
  //     office_number: '',
  //     office_number_ext: '',
  //     office_email: '',
  //     mobile_number: '',
  //     no_of_sales_people: 0,
  //     contact_time: '',
  //     sales_rep: '',
  //   },
  //   validationSchema: bookDemoFormSchema,
  //   onSubmit: async (values) => {
  //     try {
  //       const response = await axiosInstance.post(ApiEndpoint.REQUEST_DEMO, {
  //         ...{ ...values, name: `${values.first_name} ${values.last_name}` },
  //       });

  //       showSuccessMessage(
  //         `Thanks for your interest. An agent will be in touch with you shortly.`
  //       );

  //       if (response && response.data && response.data.data) {
  //         const sc = response.data.data.contact.contact_code;

  //         onSubmitSuccess && onSubmitSuccess(sc);
  //       }
  //       onClose();
  //       resetForm();
  //     } catch (error: any) {
  //       console.error(error);
  //     }
  //   },
  // });

  useEffect(() => {
    if (toggleVideo === false) {
      setVideoUrl(undefined);
    }
  }, [toggleVideo]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handlePlayVideo = (videoUrl: string | undefined) => {
    if (videoUrl !== undefined) {
      setVideoUrl(videoUrl);
      onOpenVideo();
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleCallToAssistant = () => {
    let telLink = `tel:${config.AUTO_ASSISTANT_CONTACT_NUMBER}`;
    window.open(`${telLink}`, '_blank') ||
      window.location.replace(`${telLink}`);
  };

  return (
    <Dialog
      maxWidth='md'
      fullWidth
      open={toggle}
      TransitionComponent={Transition}
      keepMounted
      onClose={() => {
        // resetForm();
        onClose();
      }}
      aria-describedby='alert-dialog-slide-description'
      sx={{
        '& .MuiPaper-root': {
          borderRadius: '12px', // Set your desired radius here
          background: `url('/static/images/img_started_now_background.png')`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: '100% 100%',
          backgroundPosition: 'center',
        },
      }}
    >
      <IconButton
        aria-label='close'
        onClick={() => {
          // resetForm();
          onClose();
        }}
        sx={{
          position: 'absolute',
          top: 8,
          right: 8,
          zIndex: 1,
          color: 'white',
          backgroundColor: 'red',
          '&:hover': {
            backgroundColor: 'rgba(255,0,0,0.7)',
          },
        }}
      >
        <CloseIcon fontSize='small' />
      </IconButton>

      <form autoComplete='off'>
        <DialogContent
          sx={{
            padding: { xs: '20px', sm: '40px' },
            my: 1,
          }}
        >
          <Grid container justifyContent={'center'} gap={3}>
            <Grid size={{ xs: 12, sm: 6.5, md: 6.5 }} alignContent={'center'}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  color: 'black',
                  gap: 2,
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                  }}
                >
                  <Box
                    component={'img'}
                    src='/static/images/qr_buddy_logo_qr.png'
                    height={{ xs: '50px', sm: '100px' }}
                    width={'auto'}
                  />
                  <Box
                    component='img'
                    src='/static/images/qr_buddy_text_logo.png'
                    alt='QR Buddy'
                    sx={{
                      height: { xs: '4vh', sm: '5vh' },
                    }}
                  />
                </Box>

                <Typography
                  sx={{
                    color: AppColors.violetColor,
                    // fontSize: 'clamp(0.875rem, 2vw, 1.25rem)', // h5 size
                    fontSize: typographyClamps.h6,
                    py: { xs: 1, sm: 2 },
                  }}
                >
                  Getting Started is Fast and Easy
                </Typography>

                <Box>
                  {featureList.map((item, index) => {
                    return (
                      <Stack
                        key={index}
                        direction='row'
                        alignItems='start'
                        py={1}
                      >
                        <Box
                          component='img'
                          src={
                            item.iconPath ??
                            '/static/images/ic_bullet_stars.png'
                          }
                          height='24px'
                          width='24px'
                        />
                        <Typography sx={{ pl: 1 }}>{item.title}</Typography>
                      </Stack>
                    );
                  })}
                </Box>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 4.5, md: 4.5 }} width={'90%'}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                }}
              >
                <Paper
                  sx={{
                    p: 2,
                    background: 'white !important',
                    width: 'inherit',
                  }}
                >
                  <Stack direction='column' spacing={1}>
                    <Typography
                      sx={{
                        fontSize: typographyClamps.h6,
                        fontWeight: 600,
                      }}
                    >
                      Order Summary
                    </Typography>
                    <List sx={{ p: 0, m: 0 }}>
                      <ListItem
                        sx={listItemStyle}
                        secondaryAction={
                          <Typography sx={priceTextStyle}>{`$${priceFormatter(
                            config.SETUP_FEE
                          )}`}</Typography>
                        }
                      >
                        <ListItemText
                          primary={
                            <Typography sx={priceTextStyle}>
                              One-Time Setup Fee
                            </Typography>
                          }
                        />
                      </ListItem>

                      <Divider />

                      <ListItem
                        sx={listItemStyle}
                        secondaryAction={
                          <Typography sx={priceTextStyle}>{`$${priceFormatter(
                            config.PRELOADED_WALLET_CREDITS
                          )}`}</Typography>
                        }
                      >
                        <ListItemText
                          primary={
                            <Typography sx={priceTextStyle}>
                              Preloaded Wallet Credits
                            </Typography>
                          }
                        />
                      </ListItem>

                      <Divider />

                      <ListItem
                        sx={listItemStyle}
                        secondaryAction={
                          <Typography
                            sx={{
                              ...priceTextStyle,
                              fontSize: typographyClamps.subtitle1,
                            }}
                          >{`$${priceFormatter(
                            config.SETUP_FEE + config.PRELOADED_WALLET_CREDITS
                          )}`}</Typography>
                        }
                      >
                        <ListItemText
                          primary={
                            <Typography
                              sx={{
                                ...priceTextStyle,
                                fontSize: typographyClamps.subtitle1,
                              }}
                            >
                              Total Due Today
                            </Typography>
                          }
                        />
                      </ListItem>

                      <ListItem>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%',
                            backgroundColor: AppColors.grayZeroColor,
                            border: `1px solid ${AppColors.grayOneColor}`,
                            borderRadius: '6px',
                            py: 1,
                          }}
                        >
                          <LockIcon color='action' fontSize='small' />
                          <Typography
                            fontSize={typographyClamps.body2}
                            pl={1}
                            sx={{
                              lineHeight: 0,
                              color: AppColors.blackColor,
                              fontWeight: 600,
                              '& span': {
                                fontWeight: 400,
                              },
                            }}
                          >
                            SSL Secure
                            <span>&nbsp;&nbsp;·&nbsp;&nbsp;256 bit</span>
                          </Typography>
                        </Box>
                      </ListItem>
                    </List>
                  </Stack>
                </Paper>

                <FormControlLabel
                  control={
                    <Checkbox
                      checked={sendFeeReceipt}
                      onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                        setSendFeeReceipt(event.target.checked)
                      }
                    />
                  }
                  label={
                    <Typography sx={{ color: AppColors.grayThreeColor }}>
                      Send me my receipt and setup steps
                    </Typography>
                  }
                  sx={{ my: 1 }}
                />

                <GradientButton sx={{ minWidth: '100%' }}>
                  Pay Now
                </GradientButton>

                <Typography
                  sx={{
                    color: 'black',
                    pt: 1.5,
                  }}
                >
                  All payments are final. Credits expire 12 months after
                  purchase.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
      </form>

      {videoUrl && (
        <VideoModel
          onClose={onCloseVideo}
          toggle={toggleVideo}
          videoUrl={videoUrl ?? ''}
          title=''
        />
      )}
    </Dialog>
  );
};

export default GetStartedModel;
